import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/PageHeader";
import { SettingsNav } from "@/components/SettingsNav";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { User } from "lucide-react";

export default function ProfileSettings() {
  const { user } = useAuth();
  const initials = `${user?.first_name?.[0] || ""}${user?.last_name?.[0] || ""}`;
  return (
    <div>
      <PageHeader title="Impostazioni" subtitle="Il tuo profilo personale" icon={User} />
      <SettingsNav />
      <Card className="max-w-2xl" data-testid="profile-form">
        <CardHeader><CardTitle className="text-base">Profilo</CardTitle></CardHeader>
        <CardContent className="space-y-5">
          <div className="flex items-center gap-4">
            <Avatar className="h-16 w-16"><AvatarImage src={user?.avatar_url} /><AvatarFallback className="bg-primary/10 text-lg text-primary">{initials}</AvatarFallback></Avatar>
            <div>
              <p className="font-medium">{user?.first_name} {user?.last_name}</p>
              <Badge variant="secondary" className="mt-1">{user?.role_label}</Badge>
            </div>
          </div>
          <div className="grid gap-4 sm:grid-cols-2">
            <div className="space-y-2"><Label>Nome</Label><Input defaultValue={user?.first_name} readOnly /></div>
            <div className="space-y-2"><Label>Cognome</Label><Input defaultValue={user?.last_name} readOnly /></div>
          </div>
          <div className="space-y-2"><Label>Email</Label><Input defaultValue={user?.email} readOnly /></div>
          <div className="flex items-center gap-2 text-sm">
            <span className="text-muted-foreground">Email verificata:</span>
            <Badge variant="outline" className={user?.email_verified ? "border-emerald-500/40 bg-emerald-500/10 text-emerald-600" : "border-amber-500/40 bg-amber-500/10 text-amber-600"}>{user?.email_verified ? "Sì" : "No"}</Badge>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
